import classNames from 'classnames';
import React from 'react';
import { StatementPdfData } from '../../../integrations/allkort/graphql/interface/StatementPdf';
import { scrollToElement } from '../../../utils/scrollUtils';
import FetchingAnimation from '../../elements/FetchingAnimation';
import { FileIcon } from '../../svgs/ExpressonSVGs';

type StatementSummaryInfoProps = {
    wrapperClasses?: string;
    latestStatementPdfData?: StatementPdfData | null;
    hasNoStatements?: boolean;
    hasSmartCard?: boolean;
}

const StatementSummaryInfo: React.FC<StatementSummaryInfoProps> = ({ 
        wrapperClasses = '',
        latestStatementPdfData = null,
        hasNoStatements = false,
        hasSmartCard = true
    }) => {

    /**
     * handleScrollClick
     * 
     * Scroll to target element by ID
     * 
     * @param IdTarget
     */
    const handleScrollClick = (IdTarget : string) => {
        scrollToElement(IdTarget);
    };

    /**
     * handleDownloadPdf
     * 
     * Opens the statement PDF in a new window
     */
    const handleDownloadPdf = () => {
        if (latestStatementPdfData?.url) {
            window.open(latestStatementPdfData.url, '_blank');
        }
    };

    if (!hasSmartCard) {
        return null;
    }

    return (
        <div
            className={classNames(
                'inv-state-statement-summary-info-widgets',
                wrapperClasses
            )}
        >
            { /* Loading component */}
            {!latestStatementPdfData && !hasNoStatements && (
                <div className="inv-state-statement-latest widget loading">
                    <span className="svg-icon-wrapper gray">
                        <FetchingAnimation width={52} height={61} borderRadius={99999} delay={0} />
                    </span>
                    
                    <div className="info-text-wrapper">
                        <span><FetchingAnimation width={170} height={15} marginBottom={6} delay={1} /></span>
                        <div className="large-paragraph"><FetchingAnimation width={200} height={22} marginBottom={6} delay={2} /></div>
                        <span className="gray"><FetchingAnimation width={170} height={15} delay={3} /></span>
                    </div>
                </div>
            )}
            
            {/* Show "no statements" message when no statements exist */}
            {hasNoStatements && (
                <div className="inv-state-statement-no-data widget">
                    <span className="svg-icon-wrapper gray">
                        <FileIcon width="28" height="28" />
                    </span>
                    
                    <div className="info-text-wrapper">
                        <span>Kontobesked</span>
                        <p className="large-paragraph">Inga kontobesked</p>
                        <span className="gray">Utan registrerade tankningar genereras inget kontoutdrag</span>
                    </div>
                </div>
            )}

            {/* Show latest statement with PDF download link when statement exists */}
            {latestStatementPdfData && !hasNoStatements && (
                <div className="inv-state-statement-latest widget">
                    <span className="svg-icon-wrapper blue">
                        <FileIcon width="28" height="28" />
                    </span>
                    
                    <div className="info-text-wrapper">
                        <span>Kontobesked</span>
                        <p className="large-paragraph">Ditt senaste kontobesked</p>
                        <span className="red" onClick={handleDownloadPdf} style={{ cursor: 'pointer' }} tabIndex={0} onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleDownloadPdf();
                            }
                        }}>
                            Ladda ner PDF
                        </span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default StatementSummaryInfo
